module.exports = __webpack_public_path__ + "img/pink-check.62ee3755.svg";